import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import { EProductType } from '@leedpulse-monorepo/enums';

export interface ICompanyStripeInfo {
  has_subscription: boolean;
  has_valid_payment: boolean;
  stripe_subscription_id?: string;
  current_period_start?: number | null;
  current_period_end?: number | null;
  upcoming_invoice?: { amount_due: number; currency: string } | null;
}

async function getCompanyStripeInfo(
  companyId: string,
  auth: Authentication
): Promise<ICompanyStripeInfo> {
  try {
    const response = await HttpClient.get(
      `/${EProductType.LEEDFLOW}/stripe/subscription/info?company_id=${companyId}`,
      auth.token
    );
    return response.data;
  } catch (e: any) {
    console.error('getCompanyStripeInfo error:', e);
    throw new GetCompanyStripeInfoFailure(e.message);
  }
}

export class GetCompanyStripeInfoFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getCompanyStripeInfo;
